'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SORTING_QUERY } from '@/constant/data';
import React from 'react';

interface SortingProps {
  updateSortBy: (sortBy: string) => void;
  currentSorting: string;
}

export default function Sorting({ updateSortBy, currentSorting }: SortingProps) {
  return (
    <div className='flex w-full flex-col gap-3 md:flex-row md:items-center'>
      <span className='text-sm'>Sort by:</span>
      <Select defaultValue={currentSorting} value={currentSorting} onValueChange={updateSortBy}>
        <SelectTrigger className='w-full md:w-48'>
          <SelectValue placeholder='Alphabetically, A-Z' />
        </SelectTrigger>
        <SelectContent className='z-[110] w-full'>
          {/* <SelectItem value='manual'>Featured</SelectItem> */}
          {SORTING_QUERY.map((item, index) => (
            <SelectItem key={index} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
